import React from 'react'

const IconSmartSet = ({ style = {}, ...props }) => {
  return (
    <svg
      width="26px"
      height="23px"
      viewBox="0 0 26 23"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>icon-smartset</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="icon-smartset" fill="#77CA34">
          <path
            d="M3,5 L23,5 L23,12 C23,14.369 22.998,16.062 22.851,17.367 C22.706,18.653 22.431,19.439 21.967,20.044 C21.7010054,20.3906929 21.3906929,20.7010054 21.044,20.967 C20.439,21.431 19.654,21.707 18.367,21.851 C17.063,22 15.37,22 13,22 C10.631,22 8.938,21.998 7.633,21.851 C6.347,21.706 5.561,21.431 4.956,20.967 C4.60932231,20.700988 4.29901197,20.3906777 4.033,20.044 C3.569,19.439 3.293,18.654 3.149,17.367 C3,16.063 3,14.37 3,12 L3,5 Z"
            id="Path"
            stroke="#77CA34"
            strokeWidth="2"
            fillOpacity="0.07"
            fillRule="nonzero"
          />
          <path
            d="M0,4 C0,2.114 0,1.172 0.586,0.586 C1.172,0 2.114,0 4,0 L22,0 C23.886,0 24.828,0 25.414,0.586 C26,1.172 26,2.114 26,4 L26,5.038 C26,5.493 26,5.72 25.86,5.866 C25.72,6.011 25.493,6.019 25.038,6.037 L13,6.5 L0.962,6.037 C0.507,6.019 0.279,6.011 0.14,5.866 C0,5.72 0,5.493 0,5.038 L0,4 Z"
            id="Path"
            fillRule="nonzero"
          />
          <path
            d="M18.354,9.47 L7.65,9.47 C7.22750217,9.47 6.885,9.81250217 6.885,10.235 C6.885,10.6574978 7.22750217,11 7.65,11 L18.354,11 C18.7764978,11 19.119,10.6574978 19.119,10.235 C19.119,9.81250217 18.7764978,9.47 18.354,9.47 Z M16.825,12.529 L9.18,12.529 C8.75750217,12.529 8.415,12.8715022 8.415,13.294 C8.415,13.7164978 8.75750217,14.059 9.18,14.059 L16.826,14.059 C17.2484978,14.059 17.591,13.7164978 17.591,13.294 C17.591,12.8715022 17.2484978,12.529 16.826,12.529 L16.825,12.529 Z M10.709,15.587 L15.296,15.587 C15.7184978,15.587 16.061,15.9295022 16.061,16.352 C16.061,16.7744978 15.7184978,17.117 15.296,17.117 L10.709,17.117 C10.2865022,17.117 9.944,16.7744978 9.944,16.352 C9.944,15.9295022 10.2865022,15.587 10.709,15.587 L10.709,15.587 Z"
            id="Shape"
            opacity="0.6"
          />
        </g>
      </g>
    </svg>
  )
}

export default IconSmartSet
